module.exports = __webpack_public_path__ + "img/pipe.ba6ea7dd.jpg";